function formatDate(iso) {
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

function statusLabel(r) {
  if (!r.found) return "Not Found";
  if (r.beatleyAvailable > 0) return "Available at Beatley";
  if (r.systemAvailable > 0) return "Available in System";
  if (r.holds > 0) return "Holds Only";
  return "Checked Out";
}

// Builds and triggers download of a CSV of the availability results.
export function exportResultsCsv(results, checkedAt) {
  const headers = [
    "Checked At", "Title", "Author", "Series", "Found", "Large Print", "Print", "Ebook",
    "Beatley Available", "Beatley Total", "System Available", "System Total", "Holds", "Status", "Catalog URL",
  ];
  const checkedLabel = checkedAt ? formatDate(checkedAt) : "";
  const rows = results.map((r) => [
    checkedLabel, r.foundTitle ?? r.title, r.foundAuthor ?? r.author, r.series ?? "",
    r.found ? "Yes" : "No", r.hasLargePrint ? "Yes" : "No", r.hasPhysical ? "Yes" : "No", r.hasEbook ? "Yes" : "No",
    r.beatleyAvailable, r.beatleyTotal, r.systemAvailable, r.systemTotal, r.holds, statusLabel(r), r.catalogUrl ?? "",
  ]);
  const csv = [headers, ...rows]
    .map((row) => row.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(","))
    .join("\n");
  const datePart = checkedAt ? new Date(checkedAt).toISOString().slice(0, 10) : "results";
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `alexandria-library-${datePart}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
